import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const LARAVEL_CHAT_API = process.env.REACT_APP_LARAVEL_API

// Async thunk for sending a message
export const providerSendMessage = createAsyncThunk(
  "chat/providerSendMessage",
  async ({ input, id, to_type, file, token }, { rejectWithValue }) => {
    try {
    //  const response = await axios.post(
    //     `${LARAVEL_CHAT_API}/admin/chatify/messages`,
    //     {
    //       message: input,
    //       to_id: id,
    //       to_type,
    //       file
    //     },
    //     {
    //       headers: {
    //         Token: token,
    //         "Content-Type": "application/json",
    //       },
    //     }
    //   );
    const formData = new FormData();
      formData.append("message", input);
      formData.append("to_id", id);
      formData.append("to_type", to_type);
      if (file) {
        formData.append("file", file); // can be image or PDF
      }

      const response = await axios.post(
        `${LARAVEL_CHAT_API}/admin/chatify/messages`,
        formData,
        {
          headers: {
            Token: token,
            // ❌ Don't set Content-Type manually — Axios sets it for FormData
          },
        }
      );

      const { chatId } = response.data;

      return {
        id: Date.now(),
        text: input,
        sender: "you",
        chatId,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchProviderMessages = createAsyncThunk(
  "providerChat/fetchProviderMessages",
  async ({ token, id, type }, thunkAPI) => {
    try {
      // const type = 'provider';
      const response = await axios.get(
        `${LARAVEL_CHAT_API}/admin/chatify/messages/${type}/${id}`,
        {
          headers: { Token: `${token}` },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch messages");
    }
  }
);

const chatSlice = createSlice({
  name: "providerChat",
  initialState: {
    messages: [],
    input: "",
    loading: false,
    error: null,
    chatId: null,
  },
  reducers: {
    setInput(state, action) {
      state.input = action.payload;
    },
    addMessage(state, action) {
      state.messages.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(providerSendMessage.fulfilled, (state, action) => {
        state.messages.push({
          id: action.payload.id,
          text: action.payload.text,
          sender: action.payload.sender,
        });
        state.input = "";

        if (action.payload.chatId) {
          state.chatId = action.payload.chatId;
        }
      })
      .addCase(providerSendMessage.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(fetchProviderMessages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProviderMessages.fulfilled, (state, action) => {
        state.loading = false;
        state.messages = action.payload.map((msg) => ({
          id: msg.id,
          text: msg.message,
          file_path: msg.file_path,
          file_name: msg.file_name,
          sender:
            msg.from_type === "Icommunetech\\Provider\\Models\\Provider" &&
            msg.from_id.toString() === localStorage.getItem("user_id")
              ? "you"
              : "other",
              timestamp: msg.created_at
        }));
      })
      .addCase(fetchProviderMessages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setInput, addMessage } = chatSlice.actions;

export default chatSlice.reducer;
